import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Colors from '../components/Colors';
import Header from '../components/header';
import Footer from '../components/footer';
import { pdfLink } from '../components/Strings';

const CustomerDetailsPage = () => {
  const { customerId } = useParams(); 
  const [customer, setCustomer] = useState(null);
  const [pending, setTotalPending] = useState(null);
  const [received, setTotalRecived] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const response = await fetch(`https://app.mirzawaleed.com/getCustomer.php?id=${customerId}`);
        const data = await response.json();
        
        if (data.success) {
          setCustomer(data.customer);
          setTotalPending(data.totalPending);
          setTotalRecived(data.totalReceived);
          setInvoices(data.invoices || []); // Set invoices if available
        } else {
          console.error('Error fetching customer details:', data.message);
        }
      } catch (error) {
        console.error('Error fetching customer details:', error);
      }
    };

    fetchCustomerDetails();
  }, [customerId]);

  const handlePrintCustomerPdf = (customerId) => {
    const url = `${pdfLink}/customerdetailpdf.php?id=${customerId}`;
    window.open(url, '_blank');
  };

  const handleInvoiceClick = (invoiceId) => {
    navigate(`/invoice/${invoiceId}`);
  };

  return (
    <>
    <Header />
    <br></br>
    <br></br>
    <div style={{padding:'8px'}}>
      {customer && (
        <div>
          <h1>Customer Details</h1>
          <p>Name: {customer.name}</p>
          <p>Location: {customer.location}</p>
          <p>Phone: {customer.phone}</p>
          <p>Pending: {pending}</p>
          <p>Received: {received}</p>
          <button onClick={() => handlePrintCustomerPdf(customer.id)} style={{padding:'8px',backgroundColor:Colors.primary,color:'white',borderRadius:'4px',cursor:'pointer'}}>Print Invoice For Customer</button>
        </div>
      )}
      
      <div>
        <h2>Invoices</h2>
        {Array.isArray(invoices) && invoices.length > 0 ? (
          invoices.map(invoice => (
            <div
              key={invoice.id}
              onClick={() => handleInvoiceClick(invoice.id)}
              style={{ cursor: 'pointer', border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}
            >
              <h3>Invoice ID: {invoice.id}</h3>
              <p>Total Price: {invoice.total}</p>
              <p>Pending Price: {invoice.pending}</p>
            </div>
          ))
        ) : (
          <p>No invoices found.</p>
        )}
      </div>
    </div>
    <br></br>
    <br></br>
    <br></br>
    <Footer/>
    </>
  );
};

export default CustomerDetailsPage;
